import { createContext, useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import gr from "./gr";
import en from "./en";

const dictionaries = { gr, en };
const LangContext = createContext(null);

export function LangProvider({ children }) {
  const { pathname } = useLocation();
  const lang = pathname === "/en" || pathname.startsWith("/en/") ? "en" : "gr";
  const prefix = lang === "en" ? "/en" : "";

  useEffect(() => {
    document.documentElement.lang = lang === "gr" ? "el" : "en";
  }, [lang]);

  const t = (path) => {
    const val = path.split(".").reduce((o, k) => (o == null ? o : o[k]), dictionaries[lang]);
    return val == null ? path : val;
  };

  const link = (to) => `${prefix}${to === "/" ? "" : to}` || "/";

  return (
    <LangContext.Provider value={{ lang, prefix, t, link }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  return useContext(LangContext);
}
